<script setup>
import { ref } from 'vue';
import InboxReconnectionRequired from '../../components/InboxReconnectionRequired.vue';

import tiktokClient from 'dashboard/api/channel/tiktokClient';

import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

const { t } = useI18n();

const isRequestingAuthorization = ref(false);

async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const response = await tiktokClient.generateAuthorization();
    const redirectUrl = response?.data?.url || response?.data?.authUrl;
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.TIKTOK.ERROR_AUTH'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <InboxReconnectionRequired class="mx-6" @reauthorize="requestAuthorization" />
</template>
